import type { RacemapEvent } from '@racemap/utilities/types/events';
import { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Outlet, useNavigate, useParams } from 'react-router';
import { useCurrentUser, useEvent } from 'src/lib/customHooks';

export interface SafemapParams extends Record<string, string> {
  eventSlug: string;
}

export function SafemapView() {
  const { eventSlug } = useParams<SafemapParams>();
  const { event, isLoading } = useEvent({ slug: eventSlug });
  const currentUser = useCurrentUser();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading && event != null && !event.isPublicSafemap && currentUser == null) {
      // Redirect to login if the event is not public and there is no current user
      navigate('/auth/login', { replace: true });
    }
  }, [isLoading, event, currentUser, navigate]);

  if (eventSlug == null) return null;

  return (
    <>
      <SafemapViewHelmet event={event} />
      <Outlet />
    </>
  );
}

const SafemapViewHelmet: React.FC<{ event?: RacemapEvent | null }> = ({ event }) => {
  return (
    <Helmet>
      <title>Racemap | Safemap {event?.name || event?.id || ''}</title>
      <meta name="description" content="Overwatch your event live with Racemap Safemap." />
      <meta name="robots" content="noindex,nofollow" />
    </Helmet>
  );
};
